<template>

  <v-container fluid class="px-0 pt-0 receiver-item">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-1 mb-5">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-store</v-icon>
        <router-link :to="{ name: (uiType === 'shipper' || uiType === 'sys-admin') ? 'receiver-list' : 'receiver-ui-receiver-location-list' }">
          Receiver Locations
        </router-link>
        <div class="separator">/</div>
        <div class="active-item" v-if="receiver">{{ receiver.name }}</div>
      </v-col>
    </v-row>

    <!-- (data loading spinner) -->
    <v-container v-if="isDataLoading" class="d-flex flex-column align-center justify-center">
      <v-progress-circular indeterminate :size="50" style="margin-bottom:30px" color="primary" />
    </v-container>

    <template v-else-if="receiver">
      <!---------------------------------------->
      <!-- Location Name, Status, and Actions -->
      <!---------------------------------------->
      <v-container fluid>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" lg="4">
            <div class="page-super-title">Receiver Location</div>
            <div class="page-title">{{ receiver.name }}</div>
            <div class="mt-5">
              <span class="form-field-label">Status:</span>
              <v-chip label outlined :class="`${receiver.receiver_status} ml-3`">
                {{ receiver.receiver_status }}
              </v-chip>
              <!-- <v-tooltip bottom v-if="receiver.receiver_status !== 'APPROVED'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-2" style="cursor:pointer;font-size:22px;" color="grey darken-1" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>While in the pending state, deliveries cannot be dispatched to this location.</div>
                <div>For a receiver to be approved, a valid license with a ship-to address must be configured.</div>
              </v-tooltip> -->
            </div>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="8" class="d-flex align-center justify-start">
            <location-status-manager
                :uiType="uiType"
                :location="receiver"
                @updated="loadReceiver" />
          </v-col>
        </v-row>
      </v-container>

      <!---------------------------------------------->
      <!-- Other Names, Phone, Appointment Handling -->
      <!---------------------------------------------->
      <v-container fluid class="mt-4 pb-5 pt-4 page-content">
        <!-- Other Names -->
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="5" lg="4" class="pt-0">
            <span class="title">Other Names</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" lg="8" class="pt-0 d-flex align-center justify-sm-center justify-lg-start">
            <v-btn color="orange darken-3" v-if="canEdit" @click="editItemDetails">
              Edit Details
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col cols="12">
            <div>
              <span class="form-field-label">DBA:</span> {{ receiver.dba }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Legal Entity Name:</span> {{ receiver.legal_entity_name }}
            </div>
          </v-col>
        </v-row>

        <!-- Phone Numbers -->
        <v-row class="pa-0 ma-0 mt-5">
          <v-col cols="12">
            <span class="title">Phone Numbers</span>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col cols="12">
            <div>
              <span class="form-field-label">main:</span>
              {{ receiver.phone }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">secondary:</span>
              {{ receiver.phone_secondary }}
            </div>
          </v-col>
        </v-row>

        <!-- Appointment Handling -->
        <v-row class="pa-0 ma-0 mt-5">
          <v-col cols="12">
            <span class="title">Appointment Handling</span>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col cols="12">
            <div>
              <span class="mr-2 form-field-label">Requires appointment?</span>
              <template v-if="receiver.requires_appointment">
                <span class="mr-3">Yes</span>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="primary" style="font-size:22px;cursor:pointer;" v-bind="attrs" v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div>This will prevent a delivery from being dispatched until appointment is confirmed by the shipper.</div>
                </v-tooltip>
              </template>
              <span v-else>No</span>
            </div>
            <div class="mt-5">
              <span class="form-field-label">Appointment URL:</span>
              {{ receiver.appointment_url }}
            </div>
            <div class="mt-5">
              <span class="form-field-label">Notes:</span>
              {{ receiver.notes }}
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!----------------------------------->
      <!-- Address and Licenses with Map -->
      <!----------------------------------->
      <v-container fluid class="mt-5 pb-5 page-content">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="5" lg="4" class="pt-0">
            <!-- <v-icon color="white" class="mr-1">mdi-map-marker-outline</v-icon> -->
            <span class="title">Ship-to Address</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" lg="8" class="pt-0 d-flex align-center justify-sm-center justify-lg-start" v-if="canEditLicenses">
            <v-btn color="orange darken-3" @click="editItemLicenses">
              Edit Licenses and Address
            </v-btn>
            <!-- (note on changes requiring approval) -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    color="grey lighten-1"
                    style="cursor:pointer;margin-left:10px"
                    v-bind="attrs"
                    v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Making changes to the address and licenses will require approval from {{ appName }}</div>
            </v-tooltip>
          </v-col>
        </v-row>

        <!-- Address, Coords, Map -->
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="5" lg="4">
            <div class="d-flex align-center mt-3">
              <v-icon color="#9c9c9c" class="pr-3">mdi-map-marker-outline</v-icon>
              <div class="address-text">
                <div>{{ multiLineAddress.street_1 }}</div>
                <div v-if="multiLineAddress.street_2">{{ multiLineAddress.street_2 }}</div>
                <div v-if="multiLineAddress.area">{{ multiLineAddress.area }}</div>
              </div>
            </div>
            <!-- <div class="mt-8">
              <span class="form-field-label">Longitude:</span>
              {{ receiver.coords.longitude }}
            </div>
            <div class="mt-6">
              <span class="form-field-label">Latitude:</span>
              {{ receiver.coords.latitude }}
            </div> -->
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" lg="8">
            <map-viewer
                height="340px"
                :settings="mapSettings"
                :markers="markers" />
          </v-col>
        </v-row>

        <v-row class="pa-0 ma-0 mt-5">
          <v-col cols="12">
            <span class="title">Facility License(s)</span>
          </v-col>
        </v-row>

        <!-- (no licenses configured) -->
        <v-row class="ma-0 pa-0 mt-2 mb-6" v-if="!hasLicenseInfo">
          <v-col cols="12" sm="12" class="form-field-subtext">
            (No licenses have been configured)
          </v-col>
        </v-row>

        <template v-else>
          <!-- Establishment License -->
          <v-row class="pa-0 ma-0 mt-2" v-if="hasEstablishmentLicenseInfo">
            <v-col cols="12" xs="12" sm="12" md="5" lg="4">
              <div class="mb-8 content-title">
                <v-icon style="font-size:20px;padding-bottom:3px;" class="mr-1">mdi-file-document</v-icon>
                Marijuana Establishment License (Adult-Use)
              </div>
              <template v-if="receiver.license_for_shipping_address === 'establishment_license'">
                <div class="mt-4 form-field-subtext">
                  <v-icon class="mr-1" style="font-size:22px;" color="primary">mdi-alert-decagram</v-icon>
                  Contains address of shipping location.
                </div>
                <div class="mt-10">
                  <span class="form-field-label">Address type:</span>
                  {{ formatLicenseCategory(receiver.establishment_license_category) }}
                </div>
              </template>
              <div class="mt-5">
                <span class="form-field-label">License number:</span>
                {{ receiver.establishment_license_number }}
              </div>
              <div class="mt-5">
                <span class="form-field-label">Issue date:</span>
                {{ formatDate(receiver.establishment_license_issue_date) }}
              </div>
              <div class="mt-5">
                <span class="form-field-label">Expiration:</span>
                {{ formatDate(receiver.establishment_license_expiration) }}
              </div>
              <div class="mt-5" v-if="receiver.establishment_license_amended_date">
                <span class="form-field-label">Amended date:</span>
                {{ formatDate(receiver.establishment_license_amended_date) }}
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="7" lg="8" align="center" justify="center">
              <v-progress-circular indeterminate :size="40" style="margin-top:110px" color="primary" v-if="isEstablishmentLicenseLoading" />
              <div class="license-doc-container" v-else-if="establishmentLicense">
                <embed style="border:2px solid #525252;" :src="establishmentLicense" width="100%" height="400" />
              </div>
              <div class="view-license-action-container" v-else-if="receiver.saved_establishment_license">
                <v-btn color="gray" @click="loadSavedEstablishmentLicense">
                  View License
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <!-- Dispensary Registration Certificate -->
          <v-row class="pa-0 ma-0 mt-8" v-if="hasDrcInfo">
            <v-col cols="12" xs="12" sm="12" md="5" lg="4">
              <div class="mb-8 content-title">
                <v-icon style="font-size:20px;padding-bottom:3px;" class="mr-1">mdi-file-document</v-icon>
                Dispensary Registration Certificate (Medical)
              </div>
              <template v-if="receiver.license_for_shipping_address === 'drc'">
                <div class="mt-4 form-field-subtext">
                  <v-icon class="mr-1" color="primary">mdi-alert-decagram</v-icon>
                  Contains address of shipping location.
                </div>
                <div class="mt-10">
                  <span class="form-field-label">Address type:</span>
                  {{ formatLicenseCategory(receiver.drc_category) }}
                </div>
              </template>
              <div class="mt-5">
                <span class="form-field-label">License number:</span>
                {{ receiver.drc_number }}
              </div>
              <div class="mt-5">
                <span class="form-field-label">Issue date:</span>
                {{ formatDate(receiver.drc_issue_date) }}
              </div>
              <div class="mt-5">
                <span class="form-field-label">Expiration:</span>
                {{ formatDate(receiver.drc_expiration) }}
              </div>
              <div class="mt-5" v-if="receiver.drc_amended_date">
                <span class="form-field-label">Amended date:</span>
                {{ formatDate(receiver.drc_amended_date) }}
              </div>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="7" lg="8" align="center" justify="center">
              <v-progress-circular indeterminate :size="40" style="margin-top:110px" color="primary" v-if="isDrcLoading" />
              <div class="license-doc-container" v-else-if="drc">
                <embed style="border:2px solid #525252;" :src="drc" width="100%" height="400" />
              </div>
              <div class="view-license-action-container" v-else-if="receiver.saved_drc">
                <v-btn color="gray" @click="loadSavedDrcLicense">
                  View License
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>

      <!-------------------->
      <!-- Contact Emails -->
      <!-------------------->
      <v-container fluid class="mt-5 pb-5 page-content">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="5" lg="4" class="pt-0">
            <span class="title">Contact Emails</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="7" lg="8" class="pt-0 d-flex align-center justify-sm-center justify-lg-start">
            <v-btn color="primary" @click="isEmailDialogOpen = true" v-if="canEdit">
              + Add Email
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0 mt-2">
          <v-col cols="12" xs="12" sm="12" md="12" lg="9">
            <template v-if="emails && emails.length > 0">
              <recipient-email-display
                  v-for="email in emails"
                  :key="email.id"
                  :maskEmails="uiType === 'shipper'"
                  :showActions="canEdit"
                  :recipientEmail="email"
                  v-on:edit="invokeEditEmail(email)"
                  v-on:delete="deleteEmail(email)" />
            </template>
            <div class="form-field-subtext" v-else>
              (No emails added)
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!----------------------------------->
    <!-- Recipient Email Editor Dialog -->
    <!----------------------------------->
    <v-dialog persistent max-width="490" v-model="isEmailDialogOpen">
      <recipient-email-editor
          :recipientEmail="emailToEdit"
          v-on:cancel="closeEditEmail"
          v-on:create="addEmail"
          v-on:update="updateEmail" />
    </v-dialog>

  </v-container>

</template>

<script>
/* eslint-disable no-unneeded-ternary */
import LocationStatusManager from '@/components/locations/LocationStatusManager'
import RecipientEmailDisplay from '@/components/app/RecipientEmailDisplay'
import RecipientEmailEditor from '@/components/app/RecipientEmailEditor'
import MapViewer from '@/components/map/MapViewer'

export default {
  name: 'ReceiverItemPage',

  components: {
    LocationStatusManager,
    RecipientEmailDisplay,
    RecipientEmailEditor,
    MapViewer
  },

  props: {
    receiverId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isDataLoading: false,
      dataLoadingError: null,
      isEstablishmentLicenseLoading: false,
      isDrcLoading: false,
      receiver: null,
      map: null,
      establishmentLicense: null,
      drc: null,
      // ---------- Email management
      emailToEdit: null,
      isEmailDialogOpen: false
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    uiType () {
      return this.$root.uiType() || 'unknown'
    },
    canEdit () {
      return (
        (this.uiType === 'sys-admin' && this.$root.activeUserHasRole('sys-admin')) ||
        (this.uiType === 'receiver' && this.$root.activeUserHasRole('admin'))
      )
    },
    canEditLicenses () {
      if (this.uiType === 'receiver') {
        return this.canEdit && this.receiver.receiver_status !== 'PENDING_APPROVAL'
      } else {
        return this.canEdit
      }
    },
    emails () {
      return (this.receiver.recipient_emails)
        ? this.$root.utils.sortBy(this.receiver.recipient_emails, ['created_at'])
        : []
    },
    hasEstablishmentLicenseInfo () {
      return (
        this.receiver.establishment_license_number ||
        this.receiver.establishment_license_issue_date ||
        this.receiver.establishment_license_expiration ||
        this.receiver.saved_establishment_license
      ) ? true : false
    },
    hasDrcInfo () {
      return (
        this.receiver.drc_number ||
        this.receiver.drc_issue_date ||
        this.receiver.drc_expiration ||
        this.receiver.saved_drc
      ) ? true : false
    },
    hasLicenseInfo () {
      return this.hasEstablishmentLicenseInfo || this.hasDrcInfo
    },
    multiLineAddress () {
      return this.$root.utils.getAddressTextFromData(this.receiver, { multi_lines: true })
    },
    locationCoords () {
      return this.receiver.coords || {}
    },
    coordinates () {
      return (this.locationCoords.longitude && this.locationCoords.latitude)
        ? [
          this.$root.utils.truncateDecimals(this.locationCoords.longitude, 5),
          this.$root.utils.truncateDecimals(this.locationCoords.latitude, 5)
        ]
        : null
    },
    markers () {
      return (this.coordinates)
        ? [{ coordinates: this.coordinates, properties: this.markerProperties }]
        : null
    },
    markerProperties () {
      return {
        name: this.receiver.name,
        alias: this.receiver.alias,
        type: 'location'
      }
    },
    mapSettings () {
      if (this.locationCoords.longitude && this.locationCoords.latitude) {
        return {
          center: [this.locationCoords.longitude, this.locationCoords.latitude],
          zoom: 15,
          pitch: 0
        }
      } else {
        return null
      }
    }
  },

  async beforeMount () {
    // Ensure receiver is loaded
    this.loadReceiver()
  },

  methods: {
    formatDate (date) {
      return (date) ? this.$root.utils.dateFormat(date, 'MM/DD/YYYY') : ''
    },

    formatLicenseCategory (code) {
      switch (code) {
        case 'retail': return 'Retail'
        case 'manufacturing_facility': return 'Manufacturing Facility'
        case 'offsite': return 'Offsite'
        case 'offsite_cultivation': return 'Offsite Cultivation'
        default: return code
      }
    },

    async loadReceiver () {
      this.isDataLoading = true

      try {
        this.receiver = await this.$store.dispatch('sh/dataApi', {
          uri: `receiver/${this.receiverId}`,
          opts: {
            params: { with: 'recipient_emails,approved_licenses' }
          }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    },

    async loadSavedEstablishmentLicense () {
      if (this.receiver.saved_establishment_license) {
        this.isEstablishmentLicenseLoading = true
        this.establishmentLicense = await this.$root.fetchLocationAsset(this.receiverId, 'establishment_license')
        this.isEstablishmentLicenseLoading = false
      }
    },

    async loadSavedDrcLicense () {
      if (this.receiver.saved_drc) {
        this.isDrcLoading = true
        this.drc = await this.$root.fetchLocationAsset(this.receiverId, 'drc')
        this.isDrcLoading = false
      }
    },

    editItemDetails () {
      this.$store.dispatch('sh/setItemToEdit', this.receiver)
      this.$root.goTo('receiver-item-edit-details', { receiverId: this.receiverId }) // go to edit page
    },

    editItemLicenses () {
      this.$store.dispatch('sh/setItemToEdit', this.receiver)
      this.$root.goTo('receiver-item-edit-licenses', { receiverId: this.receiverId }) // go to edit page
    },

    invokeEditEmail (recipientEmail = {}) {
      this.emailToEdit = recipientEmail
      this.isEmailDialogOpen = true
    },

    closeEditEmail () {
      this.isEmailDialogOpen = false
      this.emailToEdit = null
    },

    async addEmail (data = {}) {
      this.isEmailDialogOpen = false

      try {
        const bodyData = {
          location_id: this.receiverId,
          ...data
        }
        const email = await this.$store.dispatch('sh/dataApi', {
          method: 'post',
          uri: 'recipientEmail',
          opts: { bodyData }
        })

        // Add email to receiver
        this.receiver.recipient_emails.push(email)
      } catch (err) {
        console.log('Error adding email =>', err)
      }
    },

    async updateEmail (recipientEmail = {}) {
      this.isEmailDialogOpen = false
      if (!recipientEmail.id) return false

      try {
        await this.$store.dispatch('sh/dataApi', {
          method: 'post',
          uri: `recipientEmail/${recipientEmail.id}`,
          opts: { bodyData: recipientEmail }
        })
      } catch (err) {
        console.log('Error updating email =>', err)
      }
    },

    async deleteEmail (recipientEmail = {}) {
      if (!recipientEmail.id) return false

      try {
        await this.$store.dispatch('sh/dataApi', {
          method: 'delete',
          uri: `recipientEmail/${recipientEmail.id}`
        })

        // Remove email from receiver
        const existingEmails = this.receiver.recipient_emails.filter(email => email.id !== recipientEmail.id)
        this.receiver.recipient_emails = existingEmails
      } catch (err) {
        console.log('Error deleting email =>', err)
      }
    }
  }
}
</script>

<style scoped>
  .receiver-item .form-field-label {
    margin-right: 4px;
  }

  .receiver-item .content-title {
    font-size: 18px;
  }

  .receiver-item .form-field-subtext {
    color: #9a9a9a;
    font-size: 1.0em;
    font-style: italic;
  }

  .receiver-item .address-text {
    color: #ffffff;
    font-size: 1.1rem;
  }

  .receiver-item .view-license-action-container {
    border: 1px solid #525252;
    border-radius: 4px;
    padding-top: 110px;
    height: 230px;
  }

  .receiver-item .license-doc-container {
    text-align: center;
  }
</style>
